import type { ComponentProps } from "react"

export default function Files2(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 16H1V4H2V15H11V16ZM13 14V13H4V2H3V14H13ZM5 0H11.4L15 3.6V12H5V0ZM11 1V4H14V3.69L11.31 1H11ZM6 1V11H14V5H10V1H6Z"
        fill={fill}
      />
    </svg>
  )
}
